import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import BackButton from '../../../../core/design-system/components/BackButton';
import { Icon } from '../../../../core/design-system/components/Icon';
import { usePreferences } from '../../../../shared/hooks/usePreferences';
import ProfileVisibilityContent from './components/ProfileVisibilityContent';
import ActivityVisibilityContent from './components/ActivityVisibilityContent';
import './styles.css';

const PrivacySettingsPage = ({ hideHeader = false, onSubSectionChange }) => {
  const { t } = useTranslation('settings');
  const navigate = useNavigate();
  const [currentSection, setCurrentSection] = useState(null);
  const { isLoading, set, get } = usePreferences();

  // Notifier le parent quand une sous-section change
  useEffect(() => {
    if (onSubSectionChange) {
      onSubSectionChange(currentSection !== null);
    }
  }, [currentSection, onSubSectionChange]);

  const handleBack = () => {
    if (currentSection) {
      setCurrentSection(null);
    } else if (!hideHeader) {
      navigate(-1);
    }
  };

  const privacyItems = [
    {
      id: 'profileVisibility',
      label: t('pages.privacy.profileVisibility.label'),
      component: ProfileVisibilityContent,
      props: {
        selectedOption: get('profileVisibility') || 'everyone',
        onVisibilityChange: (value) => set('profileVisibility', value)
      }
    },
    {
      id: 'activityVisibility',
      label: t('pages.privacy.activityVisibility.label'),
      component: ActivityVisibilityContent,
      props: {
        selectedOption: get('activityVisibility') || 'everyone',
        onVisibilityChange: (value) => set('activityVisibility', value)
      }
    }
  ];

  const renderMainList = () => (
    <div className="preferences-list">
      {privacyItems.map((item) => (
        <button
          key={item.id}
          className="preferences-item"
          onClick={() => setCurrentSection(item.id)}
        >
          <div className="preferences-item-content">
            <span className="preferences-item-label">{item.label}</span>
          </div>
          <Icon name="chevron-right" size={20} className="preferences-item-arrow" />
        </button>
      ))}
    </div>
  );

  const renderContent = () => {
    if (!currentSection) {
      return renderMainList();
    }

    const currentItem = privacyItems.find(item => item.id === currentSection);
    if (!currentItem) return null;

    return React.createElement(currentItem.component, {
      ...currentItem.props
    });
  };

  if (isLoading) {
    return <div className="preferences-loading">{t('common.loading')}</div>;
  }

  return (
    <div className="preferences-page">
      {currentSection && (
        <header className="preferences-header">
          <BackButton onClick={handleBack} />
          <h1 className="preferences-title">
            {t(`pages.privacy.${currentSection}.title`)}
          </h1>
        </header>
      )}
      <div className="preferences-content">
        {renderContent()}
      </div>
    </div>
  );
};

export default PrivacySettingsPage; 